import { render, staticRenderFns } from "./DmDashRecentActivity.vue?vue&type=template&id=3c73bbb4&scoped=true&lang=html&"
import script from "./DmDashRecentActivity.vue?vue&type=script&lang=js&"
export * from "./DmDashRecentActivity.vue?vue&type=script&lang=js&"
import style0 from "./DmDashRecentActivity.vue?vue&type=style&index=0&id=3c73bbb4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c73bbb4",
  null
  
)

export default component.exports